import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=dad72c22&scoped=true&"
import script from "./loginLayout.vue?vue&type=script&lang=ts&"
export * from "./loginLayout.vue?vue&type=script&lang=ts&"
import style0 from "./loginLayout.vue?vue&type=style&index=0&id=dad72c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad72c22",
  null
  
)

export default component.exports